document.addEventListener('DOMContentLoaded', function () {
	document.addEventListener('wpcf7mailsent', function (event) {
		const pdfURL = document.querySelector('.pdf-download-form #ebookDLurl');

		window.location.href = pdfURL.value;
	}, false);
});
